import queryString from 'query-string';

export default () => {
	const {projectId = null, primaryEngagementId = null} = queryString.parse(location.search);

	return {projectId, primaryEngagementId};
};
